import React,{useEffect} from 'react';
import * as ReactDOM from 'react-dom';
import { Chat } from '@progress/kendo-react-conversational-ui';
import common from './common.json'
import { createPublicChannel, createCipherKey } from './common_function'
import PubNub from 'pubnub';
var request = require('request');

var user = {
  id: 1,
  avatarUrl: "https://via.placeholder.com/24/008000/008000.png",
  name:""
};
var bot = {
  id: 0,  
  avatarUrl: "https://via.placeholder.com/24/008000/008000.png",
  name:""
};

var msgTimeout;
const App = () => {

 
  const [messages, setMessages] = React.useState([]);
  const [pubnub,setPubnub] = React.useState()
  const [chatChannel,setChatChannel] = React.useState('')

  var url = new URL(window.location.href)
  var user_id = url.searchParams.get("from");
  var doctor_id = url.searchParams.get("to");
  var userName = url.searchParams.get("userName");
  var doctorName = url.searchParams.get("p_name");

  useEffect(() => {  
    addTypingIndicator() 
    var pubnubObj  =  new PubNub({
        publishKey: common.pubnub.publishKey,
        subscribeKey: common.pubnub.subscribeKey,
        uuid: user_id, // Use the UUID for identification on PubNub. 
    })
    const channel = createPublicChannel(doctor_id,user_id)
    setChatChannel(channel)
    setPubnub(pubnubObj)

      pubnubObj.subscribe(
        {
          channels: [channel], //Only one channel, split in different rows if required and load in props, can be set by load balancer.
          withPresence: true, 
        }
      )
      fetchHistory(channel,pubnubObj)

      var socket = new WebSocket(`${common.messagingWssUrl}?user_id=` + user_id);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      
      var raw = JSON.stringify({"user_id":user_id,"name":userName,"channel": channel,"target_id":doctor_id,"doctorName":doctorName});

      var options = {
        'method': 'POST',
        'body': raw,
        'url': `${common.baseUrl}addChatAttendee`
      };
  
      request(options, async function (error, response) {
        if (error){
          console.log(error)
        }
        let rs = JSON.parse(response.body)
        console.log("rs---->",rs)
        // setData(rs)
      })

      socket.onopen = function (e) {
          console.log("[open] Connection established");        
            var message = {
              "channel":channel,
              "name":userName
            }
            var socketMessage = {
              "action": "message",
              "message": message,
              "user_id": user_id,
              "target_id": doctor_id,
            }
            socket.send(JSON.stringify(socketMessage));      
      };  
      
       pubnubObj.addListener({
        message: async (msg) => {
          console.log("msd-->",msg)
            chatMessages(msg.message)
        },
        signal: async (signal) => {
            if(signal.publisher == doctor_id){
              if(signal.message.isTyping){
                activeTypingIndicator(true,signal.message.name)
              }else{
                activeTypingIndicator(false)
              }
            }else{
              activeTypingIndicator(false)
            }
        },
        presence: (presenceEvent) => {
        }
    });

    const input = document.querySelector('input');
    input.addEventListener('input', (event)=>{
      if(event.target.value.length > 0){
        sendSignal(true,channel,pubnubObj)
      }else{
        sendSignal(false,channel,pubnubObj)
      }

      // set timeout for each signal request
      if(msgTimeout != null && msgTimeout != undefined)  clearTimeout(msgTimeout);
      msgTimeout = setTimeout( () => hideTypingIndicator(), 3000)
     
    });

 },[])

 const addTypingIndicator = () =>{
  let tag = document.getElementsByClassName("k-message-list")[0]
  let div = document.createElement("div");
  let span = document.createElement("span");
  let text = document.createElement("img");
  span.id = "typingIndicaorSpan"
  div.id = "typingIndicaorGif"
  span.innerHTML = ""
  text.setAttribute("style","width:40px;height:15px")
  text.src = "/typing.gif"
  div.appendChild(span); 
  div.appendChild(text)
  tag.appendChild(div)
  div.setAttribute("style","display:none")
 }

 const activeTypingIndicator = (isTyping,name) =>{
   let elem = document.getElementById("typingIndicaorGif")
   let nextElem = document.getElementById("typingIndicaorSpan")
    if (isTyping){
      nextElem.innerHTML = `${name} is typing`
      elem.style.display="block";
    }else{
      elem.style.display = "none"
    }  
 }

  let hideTypingIndicator = () => {
    sendSignal(false,chatChannel,pubnub)
  }

  const addNewMessage = async(event) => {
    // let userName = event.message.author.name
    let message = event.message.text
            // chat message payload  
            let msg = {
              name : userName,
              payload: {
                  attendeeId:user_id,
                  message: message,
                  receivedBy: doctor_id
              },
              timestampMs: Date.now(),
              type: 'pvt-chat-message',
              child: false
            }             
      await pubnub.publish({ channel : chatChannel, message: msg})  
    //  setMessages([...messages, event.message]);
     sendSignal(false,chatChannel,pubnub)
  };

  function fetchHistory(channel,pubnubObj) {
    // console.log("channel",pubnubObj)
    pubnubObj.fetchMessages(
      {
        channels: [channel],
        count: 100
      },
      (status, response) => {
        // handle response
        response?.channels?.[channel.replace(/@/g,"%40")].forEach((data) => {
          data.message['channel'] = data.channel
          // console.log(data.message)
          chatMessages(data.message)
        })
      }
    );
  }

  const chatMessages = (message) => {
    // console.log("chatMessages",message)
    if(message.payload.receivedBy == user_id){
      bot.name = message.name
      let botResponse = Object.assign(
        {},
        {
          "author": bot,
          "text": '',
          "timestamp": '',
        }
      );
      botResponse.text = message.payload.message;
      botResponse.timestamp = new Date();
      botResponse.author = bot;
        setMessages((oldMessages) => [...oldMessages, botResponse]);
    }else{
      // bot.name = message.name
      let botResponse = Object.assign(
        {},
        {
          "author": user,
          "text": '',
          "timestamp": '',
        }
      );
      botResponse.text = message.payload.message;
      botResponse.timestamp = new Date();
      botResponse.author = user;
        setMessages((oldMessages) => [...oldMessages, botResponse]);
    }
  }

  // seinding signal typing message 
  const sendSignal = (type, channel,pubnubObj) => {    
    pubnubObj?.signal({
        channel: channel,
        message: { 
            isTyping : type,
            // to: doctor_id,
            name:userName
          }
    });      
  }
  return <div>
        <Chat user={user} messages={messages} onMessageSend={addNewMessage} placeholder={"Type a message..."} width={400} />
      </div>;
};

ReactDOM.render(<App />, document.querySelector('my-app'));